module.exports = (x, y) =>  Math.sqrt(x * x + y * y);
